import React from "react";

const Footer = () => {

    const date = new Date();
    return(
        <>
            <div className="footer">
                <p>© {date.getFullYear()} DriveLink. All rights reserved</p>
            </div>
        </>
    );
}

export default Footer;